export default __webpack_public_path__ + "static/media/torso-mid-right-side.214f189b.png";